import styled from 'styled-components'
import {InnerContent, LinkText} from '../../styles'

export const FooterSection = styled.footer`
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 28px 0;
  background-color: ${(props) =>
    props.theme.color[props.bg] ? props.theme.color[props.bg] : '#f8eee7'};
  border-top: 1px solid ${(props) => props.theme.color.darkish};
  @media (max-width: 1080px) {
    flex-direction: column;
    align-items: center;
    padding: 15px 0;
  }
  @media (max-width: 767px) {
    flex-direction: column;
    align-items: flex-start;
    padding: 15px 0;
  }
`
export const FooterInnerWrapper = styled(InnerContent)`
  align-items: center;
  @media (max-width: 1080px) {
    justify-content: center;
  }
`

export const LinksWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  @media (max-width: 1080px) {
    margin-top: 5px;
  }
`

export const Links = styled(LinkText)`
  margin: 0 10px;
`
